export default {
  pendingDiscount: (state) => state.pendingDiscount,
  discounts: (state) => state.discounts
};
